import React from 'react';

const LoadingModal = ({ show, message }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="jmodal-overlay">
      <div className="jmodal-content">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default LoadingModal;